import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=56057c1d&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=56057c1d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56057c1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56057c1d')) {
      api.createRecord('56057c1d', component.options)
    } else {
      api.reload('56057c1d', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=56057c1d&scoped=true", function () {
      api.rerender('56057c1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Tag.vue"
export default component.exports